const Wrong = () => {
    return(
        <p>Ошибка загрузки данных</p>
    )
}
export default Wrong;